import React from "react";
import { ExpandableCard, Typography, Tag } from "@ann/web-components";
import {
  ContentWrapper,
  RowWrapper,
  ColumnWrapper,
  BodyContainer,
  InfoRow,
  InlineTagWrapper,
  StatusWrapper,
} from "./AppointmentsContent.styled";

const AppointmentsContent = ({ appointments = [] }) => {
  if (!appointments.length) {
    return (
      <ContentWrapper>
        <Typography category="body" weight="regular" size="medium">
          Appointment details will appear here once they’re available.
        </Typography>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper>
      {appointments.map((appointment) => (
        <ExpandableCard key={appointment.id}>
          <ExpandableCard.Header>
            <RowWrapper>
              <ColumnWrapper className="col-1">
                <Typography category="subtitle" weight="bold" size="small">
                  Created Via
                </Typography>
                <Typography category="body" weight="regular" size="medium" color="body">
                  {appointment.createdVia}
                </Typography>
              </ColumnWrapper>
              <ColumnWrapper className="col-2">
                <StatusWrapper>
                  <Typography category="subtitle" weight="bold" size="small">
                    Status
                  </Typography>
                </StatusWrapper>
                <InlineTagWrapper>
                  {(appointment.tags || []).map((tag) => (
                    <Tag key={`${appointment.id}-${tag.text}`} color={tag.color} size="small" text={tag.text} />
                  ))}
                </InlineTagWrapper>
              </ColumnWrapper>
            </RowWrapper>
          </ExpandableCard.Header>
          <ExpandableCard.Content>
            <BodyContainer>
              {(appointment.details || []).map((detail) => (
                <InfoRow key={`${appointment.id}-${detail.label}`}>
                  <Typography category="body" weight="regular" size="medium">
                    {detail.label}
                  </Typography>
                  <Typography category="body" weight="regular" size="medium">
                    {detail.value}
                  </Typography>
                </InfoRow>
              ))}
            </BodyContainer>
          </ExpandableCard.Content>
        </ExpandableCard>
      ))}
    </ContentWrapper>
  );
};

export default AppointmentsContent;
